import ApiClient from './ApiClient';

class MenuAppsAPI extends ApiClient {
  constructor() {
    super('menu_apps', { accountScoped: true });
  }
}

export default new MenuAppsAPI();
